module.exports = __webpack_public_path__ + "img/people7.aa59e07c.png";